import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithRetry } from './baseQuery';
import { TAG_BILLING } from '@/store/tagTypes';

export interface BillingStatusDto {
  plan: string | null;
  status: string | null;
  trialEndsAt: string | null;
}

export type AccessState = 'Active' | 'GraceWarning' | 'Blocked';

export interface AccessStatusDto {
  state: AccessState;
  graceEndsAt: string | null;
  plan: string | null;
  status: string;
}

export interface StartSignupRequest {
  email: string;
  tenantName: string;
  plan: string;
}

export interface StartSignupResponse {
  checkoutUrl: string;
}

export const billingApi = createApi({
  reducerPath: 'billingApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: [TAG_BILLING],
  endpoints: (builder) => ({
    getBillingStatus: builder.query<BillingStatusDto, void>({
      query: () => '/billing/status',
      providesTags: [{ type: TAG_BILLING, id: 'STATUS' }],
    }),

    getAccessStatus: builder.query<AccessStatusDto, void>({
      query: () => '/billing/access-status',
      providesTags: [{ type: TAG_BILLING, id: 'ACCESS' }],
    }),

    startSignup: builder.mutation<StartSignupResponse, StartSignupRequest>({
      query: (body) => ({
        url: '/billing/signup',
        method: 'POST',
        body,
      }),
    }),

    removeDemoData: builder.mutation<void, void>({
      query: () => ({
        url: '/demo-data',
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: TAG_BILLING, id: 'STATUS' }],
    }),
  }),
});

export const {
  useGetBillingStatusQuery,
  useGetAccessStatusQuery,
  useStartSignupMutation,
  useRemoveDemoDataMutation,
} = billingApi;
